import { render, staticRenderFns } from "./FloatingChatWidget.vue?vue&type=template&id=99650264&scoped=true"
import script from "./FloatingChatWidget.vue?vue&type=script&lang=ts"
export * from "./FloatingChatWidget.vue?vue&type=script&lang=ts"
import style0 from "./FloatingChatWidget.vue?vue&type=style&index=0&id=99650264&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99650264",
  null
  
)

export default component.exports